export default "__VITE_ASSET__DeKQVEfH__"